import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {ContenitoreFormato} from "../../../_models/ContenitoreFormato";
import {SaveMessage} from "../../../_helpers/save-message";
import {OrganizzazioniService} from "../../../_services/organizzazioni.service";
import {MovimentiService} from "../../../_services/movimenti.service";
import {SearchResult} from "../../../_models/SearchResult";

@Component({
    selector: 'app-select-contenitore-formato',
    templateUrl: './select-contenitore-formato.component.html',
    styleUrls: ['./select-contenitore-formato.component.scss'],
    standalone: false
})
export class SelectContenitoreFormatoComponent  implements OnInit {
  @Input() inputLabel = 'Formato contenitore';
  @Input() idFormato: number;
  @Output() idFormatoChange = new EventEmitter<number>();
  formati: ContenitoreFormato[] = [];
  loading = false;
  constructor(
    private saveMessage: SaveMessage,
    private movimentiService: MovimentiService,
    private organizzazioniService: OrganizzazioniService) { }

  ngOnInit() {
    this.getFormati();
  }

  getFormati = () => {
    this.loading = true;
    this.movimentiService.getContenitoriFormatiFilteredAsync(this.organizzazioniService.organizzazioneId, '',0,0,'codice',true)
      .then((_formati: SearchResult<ContenitoreFormato>) => this.formati = _formati.result)
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento dei formati contenitori."))
      .finally(() => this.loading = false);
  };

  selectFormato = (e: SelectCustomEvent) => this.idFormatoChange.emit(+e.target.value);
}
